import { render, staticRenderFns } from "./MonitorList.vue?vue&type=template&id=3906adf6&scoped=true"
import script from "./MonitorList.vue?vue&type=script&lang=js"
export * from "./MonitorList.vue?vue&type=script&lang=js"
import style0 from "./MonitorList.vue?vue&type=style&index=0&id=3906adf6&prod&lang=scss"
import style1 from "./MonitorList.vue?vue&type=style&index=1&id=3906adf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906adf6",
  null
  
)

export default component.exports